// extracted by mini-css-extract-plugin
export default {"productGallery":"AJ-z","inQuickShop":"BJ-z"};